import React from 'react';
import c from 'classnames';

import './style.scss';

const ParagraphGrowthPathItem = ({ entity, active, className }) => {
  return (
    <div className={c('ParagraphGrowthPathItem', (active ? 'ParagraphGrowthPathItem--active' : null), className)}>
      <div className={c(
        'ParagraphGrowthPathItem__blob',
        'icon icon-blob',
        (active ? 'ParagraphGrowthPathItem__blob--active' : 'icon-variant-grey'),
      )}>
        {active ? <div className="ParagraphGrowthPathItem__blob_inner icon icon-check icon-variant-white">&nbsp;</div> : null}
      </div>
      <p className={c(
        'ParagraphGrowthPathItem__title',
        // 'u-margin--top--4',
        (active ? 'ParagraphGrowthPathItem__title--active' : null),
      )}>
        {entity.getIn(['field_title', 0, 'value'])}
      </p>
    </div>
  );
};

export default ParagraphGrowthPathItem;
